import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormType, FormStatusEnum } from 'src/app/common/enumerations/enumerations';
import { RSF } from 'src/app/components/rsf/rsf';
import { RSSWAResource } from 'src/app/components/rsswa/rsswa';
import { SCFMaster } from 'src/app/components/scf-v2/scf';
import { Document } from 'src/app/services/documents/documents';

@Component({
  selector: 'worker-verification-warning',
  templateUrl: './worker-verification-warning.component.html',
  styleUrls: ['./worker-verification-warning.component.scss']
})
export class WorkerVerificationWarningComponent extends BaseComponent {
  @Input() currentDocument?: SCFMaster | RSSWAResource | RSF | Document | null;
  warningMessage?: string;

  ngOnChanges(): void {
    this.verifyWorkerVerification();
  }

  /**
   * Shows the RSF warning while workflow actions remain blocked by an unsigned Worker Verification.
   */
  verifyWorkerVerification() {
    if (this.currentDocument?.type != FormType.RSF) return;
    const rsf = this.currentDocument as RSF;
    // Keep the warning visible as the active workflow advances through close-out statuses.
    const workerVerificationStatuses = [
      FormStatusEnum.Active,
      FormStatusEnum.HoldPoint,
      FormStatusEnum.ShieldingInspections,
      FormStatusEnum.PpsTesting,
      FormStatusEnum.PpsTestingComplete,
      FormStatusEnum.WorkCompleteFollowUps
    ];
    if (workerVerificationStatuses.includes(rsf.status) && !rsf?.workerVerificationSigned) {
      this.warningMessage = this.getMessage('RSFWorkerVerificationUnsigned').description;
    }
    else this.warningMessage = undefined;
  }
}
